import Self from "./Self/index.js";
class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/participants`;
    }
    /**
     * Returns the list of participants of a given Webinar Session (host interface).
     *
     * HTTP Method: get
     * Endpoint: /webinar/history/v1/webinars/{webinarId}/sessions/{sessionId}/participants
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async get(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(), queryParams, restRequestConfig);
        return r.data;
    }
    self() {
        return new Self(this);
    }
}
export default Index;
